export default __webpack_public_path__ + "static/media/ID_LIV_OCTOCAT Kaiju.5d420210.jpg";